export default "__VITE_ASSET__C1iSCBv6__"